import TSfDefaultLayout from './index.vue';

TSfDefaultLayout.install = app => {
  app.component(TSfDefaultLayout.name, TSfDefaultLayout);
};

export default TSfDefaultLayout;
